import React from 'react';

interface IconProps {
  color?: string;
}

function Icon({ color = '#0044F0' }: IconProps): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
      <rect width="38" height="38" x="1" y="1" stroke={color} strokeWidth="2" rx="7"></rect>
      <path
        fill={color}
        d="M20.01 26a2 2 0 0 1 0 4H20a2 2 0 1 1 0-4zM20.01 18a2 2 0 0 1 0 4H20a2 2 0 1 1 0-4zM20.01 10a2 2 0 0 1 0 4H20a2 2 0 1 1 0-4z"
      ></path>
    </svg>
  );
}

export default Icon;
